// extracted by mini-css-extract-plugin
module.exports = {"container":"gallerySection_container__3WlZQ","addImage":"gallerySection_addImage__20Y5t","inputNbColumns":"gallerySection_inputNbColumns__gGXuk","btn":"gallerySection_btn__2DP6_"};
    if(module.hot) {
      // 1783592039721
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  